// extracted by mini-css-extract-plugin
export var accent = "_8g-4";
export var add = "_8g-j";
export var addIcon = "_8g-k";
export var deleteIcon = "_8g-i";
export var disabled = "_8g-9";
export var ellipsis = "_8g-f";
export var error = "_8g-3";
export var form = "_8g-5";
export var hideFocus = "_8g-2";
export var icon = "_8g-7";
export var input = "_8g-e";
export var listItem = "_8g-h";
export var mediumHeight = "_8g-b";
export var noBorder = "_8g-8";
export var noRadius = "_8g-1";
export var shortHeight = "_8g-a";
export var tallHeight = "_8g-c";
export var textInput = "_8g-0";
export var vertical = "_8g-g";
export var veryTallHeight = "_8g-d";
export var widget = "_8g-6";